/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { axiosInstance } from "../../axios.init";

export const fetcher = async ({ method = "GET", url, params = {}, data = {}, options = {} }) => {
  return await axiosInstance({
    method,
    url,
    params,
    data,
    ...options,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};
